var _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      width: 256,
      height: 256,
      opacity: 1
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4B4B4B;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M434.115,239.04l-33.036-46.148c-8.024-10.894-18.451-19.779-30.478-25.988l-67.478-35.418 c-15.591-6.356-26.846-11.578-43.15-12.33l-18.842-0.537c-11.675-0.196-23.536,3.475-31.689,11.841l-64.217,57.638l-55.627,15.258 c-10.534,2.9-16.957,13.531-14.624,24.201l0.196,0.821c2.294,10.494,12.3,17.435,22.942,15.922l44.81-6.394 c11.178-1.591,21.966-5.223,31.826-10.709l27.081-18.275l1.386,89.883c-0.274,7.234-0.43,12.173-3.466,17.455l-91.835,159.518 c-6.561,11.374-2.685,25.9,8.649,32.51l0.791,0.459c10.729,6.257,24.455,3.241,31.562-6.932l104.908-148.37l40.182,87.94 c3.105,4.09,6.863,7.634,11.129,10.485l80.189,53.704c10.094,6.765,23.722,4.617,31.259-4.93l0.899-1.152 c3.856-4.892,5.584-11.12,4.822-17.31c-0.772-6.179-3.983-11.793-8.923-15.59l-69.158-53.138l-40.045-113.166l3.573-101.441 l48.012,14.418l50.492,49.574c6.346,6.238,16.304,6.932,23.45,1.63l0.489-0.361C438.117,258.233,439.875,247.074,434.115,239.04z",
    style: {
      fill: "rgb(40, 40, 70)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M239.735,99.221c27.227,4.169,52.688-14.536,56.867-41.773c4.158-27.237-14.546-52.698-41.784-56.867 c-27.237-4.168-52.698,14.536-56.857,41.774C193.783,69.593,212.497,95.053,239.735,99.221z",
    style: {
      fill: "rgb(40, 40, 70)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMove);
export default __webpack_public_path__ + "static/media/icon-move.09c769e258efad56eea9d7d17f887db7.svg";
export { ForwardRef as ReactComponent };